import axios from "axios";
import {
  GetToken,
  DeleteToken,
  GetLoggedInUser,
  GetAcessToken
} from "../utils";
import URL from "./url";
import store from "./../redux/store";
import Swal from "sweetalert2";

const Api = axios.create({
  baseURL: URL.API_BASEURL
});
Api.interceptors.request.use((request) => {
  const USER = GetLoggedInUser();
  if (request.headers["token"] === "static") {
    request.headers["token"] = GetAcessToken();
  } else {
    // request.headers["token"] = GetToken() ? `${GetToken()}` : "";
    if (request?.url == "auth/get-time") {
      request.headers["token"] =
        "60f291aa46ea447060f291aa46ea447019d83ba30be508e419d83ba30be508e4";
    } else if (request?.url == "auth/signin") {
      request.headers["token"] = GetAcessToken();
    } else {
      request.headers["token"] = GetToken() ? `${GetToken()}` : "";
      request.headers["Session"] = GetAcessToken();
    }
  }
  // return ;
  // Default UserId to the logged-in user, but keep one a page set itself
  // (e.g. the user being edited)
  if (USER?.UserId) {
    if (request?.method == "get") {
      request.params = { UserId: USER?.UserId, ...request.params };
    } else if (!(request.data instanceof FormData)) {
      request.data = { UserId: USER?.UserId, ...request.data };
    }
  }
  return request;
});
Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      if (error?.response?.config?.url?.includes("auth/signin")) {
      } else {
        Swal.fire({
          title: "Invalid Session",
          text: "Session expired or invalid. Please login again.",
          icon: "info"
        }).then((result) => {
          if (result.isConfirmed) {
            DeleteToken();
            store?.dispatch({ type: "LOGOUT" });
            window.location.href = "/login";
          }
        });
      }
    } else if (error?.response?.status === 403) {
    } else if (error?.response?.status === 500) {
    }
    return Promise.reject(error);
  }
);
export default Api;
